(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ia-product-lots"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
    // const variantJson = document.querySelector("[data-variant-json]").textContent
    const productJson = document.querySelector("[data-product-json]").textContent
    const product = JSON.parse(productJson)
    const productVariant = product.variants[0]
    const productPrice = product.price

    const metafieldJson = document.querySelector("[data-metafields-json]").textContent
    const metafields = JSON.parse(metafieldJson)
    const moq = metafields.moq

    if (!customElements.get("ia-product-lots")) {
        customElements.define("ia-product-lots", class IaProductLots extends HTMLElement {
            constructor() {
                super()

                const initialComputedPrice = parseInt(moq) * (productPrice / 100)
                const priceContainer = this.querySelector("#item-price-container")
                priceContainer.textContent = `$${initialComputedPrice.toFixed(2)}`

                const quantityInput = this.querySelector("#qty-input")
                quantityInput.addEventListener("change", function(ev) {
                    const inputValue = Number(ev.target.value)

                    if (inputValue > 1 && inputValue > moq) {
                        priceContainer.textContent = `$ ${parseInt(ev.target.value) * (productPrice / 100)}`
                    }
                })

                this.querySelector("#ia-qty-minus")
                    .addEventListener("click", function(ev) {
                        const inputValue = Number(quantityInput.value)
                        if (inputValue > 1 || inputValue > moq) {
                            quantityInput.stepDown()
                            priceContainer.textContent = `$ ${parseInt(quantityInput.value) * (productPrice / 100)}`
                        }
                    })

                this.querySelector("#ia-qty-plus")
                    .addEventListener("click", function(ev) {
                        const inputValue = Number(quantityInput.value)
                        quantityInput.stepUp()
                        priceContainer.textContent = `$ ${parseInt(quantityInput.value) * (productPrice / 100)}`
                    })

                const itemId = this.getAttribute('item-id')

                this.querySelector("#assorted_add_to_cart")
                    .addEventListener("click", async function(ev) {
                        ev.preventDefault()

                        if (itemId === null || itemId === undefined || itemId === "") { return }

                        const bodyData = {
                            items: [{
                                id: productVariant.id,
                                quantity: Number(quantityInput.value)
                            }]
                        }

                        const addToCartResponse = await fetch("/cart/add.js", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(bodyData)
                        })

                        if (!addToCartResponse.ok) {
                            console.error("add to cart failed")
                        }

                        const getCartDataResponse = await fetch("/cart.js", {
                            method: "GET",
                            headers: { "Content-Type": "application/json" },
                        })
                        
                        if (!getCartDataResponse.ok) {
                            console.error("add to cart failed")
                        }

                        const cartData = await getCartDataResponse.json()
                        const cartCountDiv = document.createElement("div")
                        cartCountDiv.classList.add("cart-count-bubble")
                        cartCountDiv.append(cartData.item_count)
                        document.querySelector("#cart-icon-bubble").append(cartCountDiv)

                        // <span class="visually-hidden">${cartData.item_count} item</span>
                        // const itemId = ev.target.dataset.item
                        // console.log(ev.target.dataset.item)
                    })
            }
        })
    }
})
  } catch(e) { console.error(e); }
})();

})();
